<template>
	<div class="accordion">
		<div class="accordion-header accordion-trigger">
			<slot name="header"></slot>
			<span :class="['accordion-icon', { expanded: isOpen } ]" @click="toggleAccordion"></span>
		</div>
		<div :class="['accordion-body', { open: isOpen } ]">
			<slot name="body"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Accordion',
	props: {
	},
	data() {
		return {
			isOpen: true,
		};
	},
	methods: {
		toggleAccordion() {
			this.isOpen = !this.isOpen;
		},
	},
};
</script>

<style lang="scss" scoped>
	.accordion {
		.line-items {
			width: 100%;
		}
	}

	.accordion-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.accordion-icon {
		height: 100%;
		text-align: left;

		&:after {
			content: '▲';
			display: inline-block;
			height: 100%;
			transform: rotate(180deg);
			margin-left: 1ch;
			transition: all $ui-transition-duration-short ease-in;

			.you-pay-section & { color: $primary-color-extra-light; }
		}

		&:hover:after { cursor: pointer; }
		&.expanded:after { transform: rotate(0deg); }
	}

	.accordion-body {
		margin: 10px auto;
		max-height: 0;
		overflow: hidden;
		transition: all $ui-transition-duration ease-in;

		&.open { max-height: 10em; }
	}
</style>
